import * as RefApi from 'saas/references/api';
import * as ProductApi from 'saas/products/api';
import { createAction } from 'redux-actions';
import * as RefConstants from 'saas/references/constants';
import * as UsersApi from 'saas/users/api';

export const fetchRequirementsAction = createAction('case.FETCH_REQUIREMENTS');
export const fetchRequirementsSuccessAction = createAction(
  'case.FETCH_REQUIREMENTS_SUCCESS'
);

export const fetchRequirements = siteCase => (dispatch, getState) => {
  if (getState().requirements.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchRequirementsAction);

  const doFetch = () =>
    Promise.all([
      RefApi.getAASTReferencesByType(RefConstants.AAST_HOUSING_TYPE, siteCase),
      RefApi.getAASTReferencesByType(RefConstants.AAST_ANNEXES, siteCase),
      ProductApi.getAASTProducts(),
      UsersApi.getAllWorkers(),
      RefApi.getReferencesByType(RefConstants.TIME_UNIT, siteCase),
      RefApi.getAASTReferencesByType(RefConstants.ASST_SOIL_TYPE, siteCase),
    ]);

  // Fetching requirements and planning
  const promise = doFetch().then(response =>
    dispatch(
      fetchRequirementsSuccessAction({
        housingTypes: response[0],
        annexes: response[1],
        products: response[2],
        workers: response[3],
        timeUnits: response[4],
        soilTypes: response[5],
      })
    )
  );

  return promise;
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/actions/requirements.js